import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../../config/api';
import SettingNumber from '../SettingNumber';

const DEFAULT_MAX_TESTERS = 50;

const BetaSettingsTab: React.FC = () => {
  const [seats, setSeats] = useState<{ taken: number; max: number } | null>(null);

  const loadSeats = useCallback(async (maxOverride?: number) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/beta/spots`, { withCredentials: true });
      const taken = Number(response.data?.taken);
      const max = typeof maxOverride === 'number' ? maxOverride : Number(response.data?.max);
      if (Number.isInteger(taken) && Number.isInteger(max) && max >= 0) {
        setSeats({ taken: Math.max(0, taken), max });
      }
    } catch {
      setSeats(null);
    }
  }, []);

  useEffect(() => {
    loadSeats();
  }, [loadSeats]);

  return (
    <div className="row g-3">
      <div className="col-12 col-xl-6">
        <div className="card h-100 shadow-sm border-0">
          <div className="card-header bg-white border-0 pb-0">
            <div className="d-flex align-items-center gap-2">
              <span
                className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                style={{ width: '2rem', height: '2rem' }}
              >
                <FontAwesomeIcon icon={faUsers} />
              </span>
              <h5 className="mb-0">Program</h5>
            </div>
            <div className="text-muted small">Capacity shown on the public beta landing page.</div>
          </div>
          <div className="card-body">
            <div className="rounded-3 bg-light border p-3">
              <SettingNumber
                apiBaseUrl={API_BASE_URL}
                settingKey="beta_max_testers"
                title="Max number of testers allowed"
                description="Total beta tester seats. The landing page shows how many of these spots are still open."
                defaultValue={DEFAULT_MAX_TESTERS}
                min={0}
                saveDescription="Maximum number of beta testers allowed"
                suffix={seats ? (
                  <span className="text-muted small">
                    {seats.taken} of {seats.max} seats filled
                  </span>
                ) : null}
                onSaved={(max) => loadSeats(max)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetaSettingsTab;
